import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import axios from "axios";
import { createStore } from "vuex";

// Create a new store instance.
const store = createStore({
  state: {
    // public list
    events: [],
  },
  getters: {
    events: (state) => {
      return state.events;
    },
  },
  mutations: {
    loadEvents: (state, payload) => {
      state.events = [...payload];
    },
  },
  actions: {
    loadEvents: ({ commit }, payload) => {
      commit("loadEvents", payload);
    },
  },
});

axios.defaults.baseURL = process.env.VUE_APP_ZOO_SPOL_API_ENDPOINT;

const app = createApp(App);
app.use(store);
app.use(router);
app.mount("#app");
